// src/components/services/locationService.js
import api from "../components/Api/Api"; // Import the API instance

class LocationService {
  // Obtener todas las provincias
  async getProvinces() {
    try {
      const response = await api.get("/api/provinces");
      return response.data;
    } catch (error) {
      console.error("Error loading provinces:", error);
      throw error;
    }
  }

  // Obtener cantones por provincia
  async getCantonsByProvince(provinceId) {
    try {
      const response = await api.get(`/api/provinces/${provinceId}/cantons`);
      return response.data;
    } catch (error) {
      console.error("Error loading cantons:", error);
      throw error;
    }
  }

  // Obtener distritos por cantón
  async getDistrictsByCanton(cantonId) {
    try {
      const response = await api.get(`/api/cantons/${cantonId}/districts`);
      return response.data;
    } catch (error) {
      console.error("Error loading districts:", error);
      throw error;
    }
  }

  // Obtener barrios por distrito
  async getNeighborhoodsByDistrict(districtId) {
    try {
      const response = await api.get(`/api/districts/${districtId}/neighborhoods`);
      return response.data;
    } catch (error) {
      console.error("Error loading neighborhoods:", error);
      throw error;
    }
  }

  // Obtener sectores
  async getSectors() {
    try {
      const response = await api.get("/api/sectors");
      return response.data;
    } catch (error) {
      console.error("Error loading sectors:", error);
      throw error;
    }
  }

  // Obtener regímenes
  async getRegimes() {
    try {
      const response = await api.get("/api/regime_id");
      return response.data;
    } catch (error) {
      console.error("Error loading regimes:", error);
      throw error;
    }
  }

  // Obtener países
  async getCountries() {
    try {
      const response = await api.get("/api/countries");
      return response.data;
    } catch (error) {
      console.error("Error loading countries:", error);
      throw error;
    }
  }
}

export default new LocationService();